import BaseComponent from '@/js/core/BaseComponent'
import screenfull from 'screenfull'
import $ from 'jquery'

export default class Fullscreen extends BaseComponent {
  state = {
    ...this.state,
    isFullscreen: false,
  }

  onFullscreenUpdate () {
    const { isFullscreen } = screenfull

    this.setState(() => ({ isFullscreen }))

    if (!isFullscreen) {
      screenfull.off('change', this.onFullscreenUpdateBind)
    }
  }

  fullscreenRequest (element) {
    if ($.device.android && screenfull.isEnabled) {
      screenfull.on('change', this.onFullscreenUpdateBind)
      screenfull.request(element)
    }
  }

  mounted () {
    super.mounted()
    this.onFullscreenUpdateBind = this.onFullscreenUpdate.bind(this)
  }
}